import Reveal3 from '@/components/marketing3/Reveal3'
import MarketPositionStrip from '@/components/marketing3/widgets/MarketPositionStrip'

/**
 * MarketIntel3 (light) — "Know where you stand — every day." Value copy carried from v1
 * with the packaging/availability sentence and its badge removed per plan §0 (no
 * plan/packaging talk anywhere). Visual: MarketPositionStrip (W9).
 *
 * Copy is quoted VERBATIM from docs/marketing/2026-07-05-landing3-copy.md §Market
 * intelligence. No packaging talk, no availability badge, no OTA name, no data-collection
 * mechanics. No PMS name. Illustrative money figures live in the widget only.
 *
 * De-engineer'd 2026-07-05 (founder direction): the comp-set selection adjective and the
 * data-taxonomy enumeration were dropped to reduce reverse-engineering surface, and the
 * cadence claim was softened out of the body (the H2 keeps "every day"). The "named line in
 * the Rate Ledger — never a silent hand on the till" idea is preserved. See the copy doc's
 * §Market intelligence and claims-register §2/§7 for what was retired and why.
 */
export default function MarketIntel3({ brand }: { brand: string }) {
  return (
    <section id="market" className="scroll-mt-24" aria-labelledby="market-heading">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-24 sm:px-6 sm:py-28 lg:grid-cols-2 lg:gap-16">
        <div>
          <Reveal3>
            <p className="mkt3-eyebrow">Market intelligence</p>
            <h2 id="market-heading" className="mkt3-display mkt3-h2 mt-5">
              Know where you stand — every day.
            </h2>
          </Reveal3>
          <Reveal3 delay={100}>
            <p className="mkt3-prose mt-6">
              {brand} always knows where you stand against comparable rooms. When you&rsquo;re leaving money on the
              table, Market Position nudges you up; when the market softens, it keeps you honest. Like everything else
              in the engine, it shows up as a named line in the Rate Ledger — never a silent hand on the till.
            </p>
          </Reveal3>
        </div>

        <Reveal3 delay={160}>
          <MarketPositionStrip />
        </Reveal3>
      </div>
    </section>
  )
}
